import React from "react";

function useSmartPosition<T extends HTMLElement>(
  triggerRef: React.RefObject<HTMLElement | null>,
) {
  const [contentEl, setContentEl] = React.useState<T | null>(null);

  React.useLayoutEffect(() => {
    if (!contentEl) {
      return;
    }

    const contentRect = contentEl.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    const mainEl = document.querySelector("main");
    const mainPaddingLeft = parseFloat(
      window.getComputedStyle(mainEl!).paddingLeft || "0",
    );

    const rightOverflow = contentRect.right > screenWidth;
    const overflowRight = contentRect.right - screenWidth;

    if (rightOverflow) {
      const leftOffset = overflowRight + mainPaddingLeft;
      contentEl.style.left = `-${leftOffset}px`;
    }
  }, [contentEl]);

  const refCallback = React.useCallback((node: T | null) => {
    setContentEl(node);
  }, []);

  return [refCallback];
}

export default useSmartPosition;
